import { ReactComponent as MilestoneBlockedIcon } from 'assets/svgs/milestone-blocked.svg';
import { ReactComponent as MilestoneCompletedIcon } from 'assets/svgs/milestone-completed.svg';
import { ReactComponent as MilestoneInProgressIcon } from 'assets/svgs/milestone-inprogress.svg';
import { ReactComponent as MilestoneTodoIcon } from 'assets/svgs/milestone.svg';

export const MilestoneTodo = MilestoneTodoIcon;
export const MilestoneInProgress = MilestoneInProgressIcon;
export const MilestoneCompleted = MilestoneCompletedIcon;
export const MilestoneBlocked = MilestoneBlockedIcon;
